import { z } from 'zod';

export const TodoItemSchema = z.object({
  id: z.string().optional(),
  title: z.string().min(1, '請輸入標題'),
  remindTime: z.string(),
  repeat: z.array(z.number()),
});

export type TodoItem = z.infer<typeof TodoItemSchema>;
